import store from "../../store/store";

export const componentKey = "DOCUMENTS_SLICE";

const { actions } = store.reducerManager.add({
  key: componentKey,
  addedReducers: {
    setDocumentListData: (state, action) => {
      state.documentListData = action.payload;
    },
    setCloseDocumentDialog: (state, action) => {
      state.closeDocumentDialog = action.payload;
    },
  },
  initialReducerState: {
    documentListData: {},
    closeDocumentDialog: false,
  },
});

export const { setDocumentListData, setCloseDocumentDialog } = actions;
